export default __webpack_public_path__ + "static/media/system_03_08.fefbbc83.jpg";